import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Grid, IconButton, InputAdornment, TextField } from '@mui/material';
import { useDebounce } from 'use-debounce';
import SearchIcon from '@mui/icons-material/Search';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import PopupTitle from '../common/popup_title';
import { searchFoodDataOperation } from '../../operations/recipes_operations';
import {
  foodDataSourceLabel,
  nutritionOneLineSummary,
} from '../../services/nutrition';

const IngredientStructuredDataEditSearchIngredientPage = ({
  initialSearchText,
  onBack,
  onChooseFoodDataItem,
}) => {
  const [searchText, setSearchText] = useState(initialSearchText);

  const [searchResult, setSearchResult] = useState(null);

  const [debouncedSearchText] = useDebounce(searchText, 500);

  useEffect(() => {
    if (debouncedSearchText && debouncedSearchText.length > 2) {
      searchFoodDataOperation({ searchString: debouncedSearchText }, 0).then(
        setSearchResult,
      );
    }
  }, [debouncedSearchText]);

  return (
    <Grid container style={{ minHeight: '240px', maxHeight: '480px' }}>
      <Grid item xs={12}>
        <PopupTitle
          backButtonEnabled={!!onBack}
          onClickBack={onBack}
          titleText="Search Ingredient"
        />
      </Grid>
      <Grid item xs={12}>
        <Grid container style={{ padding: '8px' }}>
          <Grid item xs={12}>
            <TextField
              variant="standard"
              fullWidth
              value={searchText}
              onChange={(ev) => setSearchText(ev.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <IconButton
                      aria-label="toggle password visibility"
                      tabIndex={-1}
                      edge="end">
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          {(searchResult?.data || []).map((item) => (
            <Grid
              item
              xs={12}
              key={item.source + item.foodDataID}
              style={{ padding: '8px' }}>
              <Grid container>
                <Grid item xs={11}>
                  <div style={{ fontSize: '14px' }}>{item.foodName}</div>
                  <div style={{ fontSize: '12px', color: '#7b7b7b' }}>
                    {nutritionOneLineSummary(item.nutritionPer100g)}
                  </div>
                  <div style={{ fontSize: '12px', color: '#7b7b7b' }}>
                    {foodDataSourceLabel(item.source)}
                  </div>
                </Grid>
                <Grid item xs={1}>
                  <IconButton
                    onClick={() => onChooseFoodDataItem(item)}
                    color="primary"
                    edge="end"
                    aria-label="add">
                    <AddCircleIcon style={{ width: '32px', height: '32px' }} />
                  </IconButton>
                </Grid>
              </Grid>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
};

IngredientStructuredDataEditSearchIngredientPage.propTypes = {
  initialSearchText: PropTypes.string.isRequired,
  onBack: PropTypes.func.isRequired,
  onChooseFoodDataItem: PropTypes.func.isRequired,
};

export default IngredientStructuredDataEditSearchIngredientPage;
